'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hi_IN = require('../locale/hi_IN');

var _hi_IN2 = _interopRequireDefault(_hi_IN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _hi_IN2['default'];